import React from 'react';
import withFeatureFlags from 'hocs/withFeatureFlags';
import Legacy from './Legacy';
import Login from './Login';

function LoginSwitch(props) {
  const { enableCmpLogin, ...rest } = props;
  const Component = enableCmpLogin ? Login : Legacy;

  return <Component {...rest} />;
}

function mapFlagsToProps(flags) {
  return {
    enableCmpLogin: flags.enableCmpLogin,
  };
}

export default withFeatureFlags(mapFlagsToProps)(LoginSwitch);
